import { Popper, PopperProps } from "@mui/material";

export type SHPopperProps = PopperProps;
export const SHPopper = (props: SHPopperProps): JSX.Element => (
  <Popper {...props} />
);
